
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';


@Component({
  name: 'catalog-product-family-products',
  components: {
    ...ServiceContainer().getComponents(),
  }
})

export default class extends Vue {

  @Prop({required: true}) private familyProducts: Array<object>;
  @Prop({required: true}) private parentProduct: Array<object>;

  private dropdownActive: boolean = false;

  private goToLink(option: object): void {
    window.location.assign(option['url_key']);
  }

  private imageSrc(product: object): string {
    if (product['image'] === 'no_selection' || !product.hasOwnProperty('image')) {
      return '/area/web/default/assets/images/logo.svg';
    }
    return `${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:265/h:265/extend:true/background:255:255:255/path/media/catalog/product${product['image']}`;
  }

  private toggleDropdown(): void {
    this.dropdownActive = !this.dropdownActive;
  }

  private mounted() : void {
    document.addEventListener('click', ()=>{
      this.dropdownActive = false;
    });
    document.addEventListener("keydown", (event) => {
      const key = event.key; // Or const {key} = event; in ES6+
      if (key === "Escape") {
        this.dropdownActive = false;
      }
    });
  }
}
